import React, { Component } from 'react';
import { Button, Modal, Icon } from 'antd';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import ConnectDomain from '../ConnectDomain';
import DomainWarning from '../ConnectDomain/DomainWarning';
import { VERSION_TICK } from '../../config/media';
import { SetupAction } from '../../actions';
import { DomainWrapper } from './style';
import { Rive } from '../RiveComponent';
import RenderSetup from './RenderSetup';
import SetupEmailSuccess from './SetupEmailSuccess';
import { DashLinksToolTip } from './Utils';

class Domain extends Component {
    constructor(props) {
        super(props)
        this.state = {
            visible: false,
            isConfig: false,
            width: 750,
            isWarning: false,
            isEmailSet: false,
            isSetupEmail: false,
            setupWidth:'33rem',
        }
    }

    handleConfig = () => {
        const { exchange } = this.props;
        this.setState({
            isConfig: true,
            isWarning: (exchange.is_running)
                ? true
                : false
        });
    }

    handleClose = () => {
        this.setState({ isConfig: false, isSetupEmail: false });
    };

    handleWidth = (value) => {
        this.setState({ width: value });
    };

    handleCloseWarning = () => {
        this.setState({ isWarning: false });
    };

    renderContent = () => {
        const { isConfig, isWarning, isSetupEmail } = this.state;
        const { exchange, biz, updateBiz, constant, handleCloud } = this.props;
        if (isWarning) {
            return (
                <DomainWarning
                    handleClose={this.handleCloseWarning}
                />
            );
        } else if (isConfig) {
            return (
                <ConnectDomain
                    exchange={exchange}
                    biz={biz}
                    updateBiz={updateBiz}
                    handleCloud={handleCloud}
                    handleWidth={this.handleWidth}
                    onCancel={this.handleClose}
                    constant={constant}
                    history={this.props.history}
                />
            )
        } else if (isSetupEmail) {
            return (
                <RenderSetup 
                    updateWidth={this.updateWidth} 
                    onCancel={this.handleClose} 
                    history={this.props.history} 
                    handleSetup={this.handleSetup}
                    exchange={exchange}
                    handleCloud={handleCloud}
                />
            )
        } else {
            return null;
        }
    };

    updateWidth = (width) =>{
        this.setState({ setupWidth:width })
    }

    handleSetup = () => {
        this.setState({ isSetupEmail:true })
    }

    render() {
        const { isConfig, width, isWarning, isEmailSet, isSetupEmail, setupWidth} = this.state;
        const { biz, events, exchange } = this.props;
        const isEventProgressing = !!events.filter(evt => (evt.status === 1 || evt.status === 0)).length;

        return (
            <DomainWrapper>
                <div className='domain-wrapper'>
                    <div className="title-container">
                        <div className="main-title">
                            Connect domain
                        </div>
                        <div className='domain-dash-link-wrapper'>
                            <div className="content d-flex">
                                <span style={{marginTop:'1%'}}>Setup and connect your domain to your exchange.</span>
                            </div>
                            <div className='domain-dash-link'>
                                <DashLinksToolTip renderLink={'https://www.youtube.com/watch?v=f1ITHvCgUpM&t=7s'}/>
                            </div>
                        </div>
                    </div>
                    <div className="custom-domain-container">
                        <div className="d-flex domain-container">
                            <div>
                                {(biz.DOMAIN && biz.URL)
                                    ? <img src={VERSION_TICK} alt="tick" className="content-icon" />
                                    : <Icon
                                        type="info-circle"
                                        style={{ fontSize: '32px', color: '#00f' }}
                                    />
                                }
                            </div>
                            <div className="custom-domain-content">
                                <span className="bold">
                                    Main domain:
                                        </span>
                                <span className="space">
                                    {biz.DOMAIN
                                        ? biz.DOMAIN
                                        : '(not set)'
                                    }
                                </span>
                                <div>
                                    <span className="bold">
                                        API domain:
                                            </span>
                                    <span className="space">
                                        {exchange && exchange.url
                                            ? exchange.url
                                            : '(not set)'
                                        }
                                    </span>
                                </div>
                            </div>
                        </div>
                        <div className="btn-wrapper">
                            <Button
                                type="primary"
                                onClick={this.handleConfig}
                                disabled={isEventProgressing}
                            >
                                {(biz.DOMAIN && biz.URL)
                                    ? 'Update'
                                    : 'Configure'
                                }
                            </Button>
                        </div>
                    </div>
                </div>
                {/* <div className="divider" /> */}
                <div className='email-wrapper'>
                    <div className="title-container">
                        <div className="main-title">
                                Setup email
                        </div>
                        <div className="content">
                        Automated system for sending your users important emails (sign up, withdrawals, etc).
                        </div>
                        <div className='domain-dash-link-wrapper'>
                            <div className="content" style={{marginTop:'0.5%'}}>
                                If you have already set the email on your exchange operator control, you can ignore this.   
                            </div>
                            <div className='domain-dash-link'>
                                <DashLinksToolTip renderLink={'https://www.youtube.com/watch?v=EB6n3-X5jEM&t=128s'} />
                            </div>
                        </div>
                    </div> 
                    <div className="custom-domain-container">
                        <div className="d-flex domain-container">
                            <div>
                                {/* {exchange.smtp && exchange.smtp.verified
                                    ? <img src={EMAIL_DOMAIN_SET} alt="email" className="content-icon" />
                                    : <img src={EMAIL_DOMAIN} alt="email" className="content-icon" /> 
                                } */}
                                <Rive src={'updateEmail.riv'} />
                            </div>
                            <div className="custom-domain-content">
                                    <span className="bold">
                                        Email domain:
                                    </span>
                                    {exchange.smtp && exchange.smtp.verified
                                        ?
                                        <span className="space link" onClick={()=> this.handleSetup()}>
                                           {exchange.smtp.domain}
                                        </span>
                                        :
                                        <span className="space">(not set)</span>
                                    }
                            </div>
                        </div>
                        <div className="btn-wrapper">
                        <Button
                            type="primary"
                            onClick={this.handleSetup}
                            disabled={isEmailSet}
                        >
                               {exchange.smtp && exchange.smtp.verified ? "Update" : "Setup"}
                        </Button>
                    </div>
                    </div>
                    </div>
                    <SetupEmailSuccess />
                <Modal
                    visible={isConfig || isSetupEmail}
                    footer={null}
                    width={
                        isSetupEmail 
                        ? setupWidth 
                        : isWarning
                            ? '400px'
                            : `${width}px`
                    }
                    onCancel={this.handleClose}
                >
                    {this.renderContent()}
                </Modal>
            </DomainWrapper>
        )
    }
}

const mapStateToProps = (state) => ({
    exchange: state.exchange && state.exchange.length ? state.exchange[0] : {},
    biz: state.biz,
    constant: state.constant,
    events: state.constant.events
});

const mapDispatchToProps = (dispatch) => ({
    updateBiz: bindActionCreators(SetupAction.updateBiz, dispatch),
});

export default connect(mapStateToProps, mapDispatchToProps)(Domain);
